import { DocumentFolderTreeNode } from 'compliance-api';
import { useCallback, useState } from 'react';
import { useDeleteFolderMutation } from '@/modules/admin-dashboard/queries/documents-folders.ts';
import { BaseModalProps, Button, CustomCheckbox, ModalContentWrapper } from 'ui';

interface DeleteFolderModalProps extends BaseModalProps {
  folder: DocumentFolderTreeNode;
}

const DeleteFolderModal = ({ open, folder, onClose }: DeleteFolderModalProps) => {
  const [force, setForce] = useState(false);

  const hasContent = !!folder.documents_count || !!folder.children_count;

  const { mutateAsync, isLoading } = useDeleteFolderMutation();

  const handleDelete = useCallback(async () => {
    await mutateAsync({ force, folderId: folder.id });
    onClose();
  }, [folder.id, force, mutateAsync, onClose]);
  return (
    <ModalContentWrapper
      title={`Are you sure you want to archive the folder called "${folder.name}"?`}
      open={open}
      onClose={onClose}
    >
      <div className="space-y-3">
        {hasContent && (
          <div className="space-y-2">
            <div>
              This folder is not empty, are you sure you want to archive it and all its contents?
            </div>
            <CustomCheckbox
              checked={force}
              onChange={() => setForce(!force)}
              label="I confirm archiving"
            />
          </div>
        )}
        <Button
          disabled={isLoading || (hasContent && !force)}
          loading={isLoading}
          onClick={handleDelete}
        >
          Archive folder
        </Button>
      </div>
    </ModalContentWrapper>
  );
};

export default DeleteFolderModal;
